var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"id":"layout-wrapper"}},[_vm._t("default",null,{"domain":_vm.domain,"user":_vm.user})],2),_vm._v(" "),_c('RightBar')],1)}
var staticRenderFns = []

export { render, staticRenderFns }